import { render, staticRenderFns } from "./CustomerBillHistoryTab.vue?vue&type=template&id=dc940336&scoped=true"
import script from "./CustomerBillHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerBillHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerBillHistoryTab.vue?vue&type=style&index=0&id=dc940336&prod&scoped=true&lang=css"
import style1 from "./CustomerBillHistoryTab.vue?vue&type=style&index=1&id=dc940336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc940336",
  null
  
)

export default component.exports